import SiafLiteApiRepository from "../../external/siafLiteApi";

class MdfeService {
  constructor() {
    this.urlBase = "/faturamento/mdfe";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  cadastrarCondutor(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/condutor`
    ).post(body);
  }

  cadastrarMunicipioCarregamento(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/municipio-carregamento`
    ).post(body);
  }

  cadastrarReboque(id, body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/${id}/reboque`).post(
      body
    );
  }

  cadastrarNfSaida(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nf-saida`
    ).post(body);
  }

  cadastrarPercurso(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/percurso`
    ).post(body);
  }

  cadastrarLacre(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/lacre`
    ).post(body);
  }

  cadastrarPedagio(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/pedagio`
    ).post(body);
  }

  cadastrarContratante(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/contratante`
    ).post(body);
  }

  cadastrarCiot(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/ciot`
    ).post(body);
  }

  emitirNotaFiscal(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/emitir`
    ).get();
  }

  cancelar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(
      id,
      body,
      "nota-fiscal/cancelamento"
    );
  }

  encerrar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(
      id,
      {},
      "nota-fiscal/encerramento"
    );
  }

  getDanfe(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/xml/danfe`
    ).get();
  }
  
  getArquivoXml(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/xml/arquivo`
    ).get();
  }
}

export default MdfeService;
